// 过敏原和其他菜品标识
export const ALLERGEN = [{
    key: 'gluten',
    text: 'text_gluten',
    active: false,
}, {
    key: 'crustaceans',
    text: 'text_crustaceans',
    active: false,
}, {
    key: 'eggs',
    text: 'text_eggs',
    active: false,
}, {
    key: 'fish',
    text: 'text_fish',
    active: false,
}, {
    key: 'peanuts',
    text: 'text_peanuts',
    active: false,
}, {
    key: 'soya',
    text: 'text_soya',
    active: false,
}, {
    key: 'milk',
    text: 'text_milk',
    active: false,
}, {
    key: 'tree_nuts',
    text: 'text_tree_nuts',
    active: false,
}, {
    key: 'celery',
    text: 'text_celery',
    active: false,
}, {
    key: 'mustard',
    text: 'text_mustard',
    active: false,
}, {
    key: 'sesame',
    text: 'text_sesame',
    active: false,
}, {
    key: 'sulphites',
    text: 'text_sulphites',
    active: false,
}, {
    key: 'lupin',
    text: 'text_lupin',
    active: false,
}, {
    key: 'molluscs',
    text: 'text_molluscs',
    active: false,
}, {
    key: 'mild_spicy',
    text: 'text_mild_spicy',
    active: false,
},
{
    key: 'medium_spicy',
    text: 'text_medium_spicy',
    active: false,
},
{
    key: 'very_spicy',
    text: 'text_very_spicy',
    active: false,
},
{
    key: 'frozen_origin',
    text: 'text_frozen_origin',
    active: false,
},
{
    key: 'blast_freezing',
    text: 'text_blast_freezing',
    active: false,
},
{
    key: 'vegetarian',
    text: 'text_vegetarian',
    active: false,
},
{
    key: 'vegan',
    text: 'text_vegan',
    active: false,
},
{
    key: 'gluten_free',
    text: 'text_gluten_free',
    active: false,
},
{
    key: 'raw',
    text: 'text_raw',
    active: false,
},
{
    key: 'cooked',
    text: 'text_cooked',
    active: false,
},
{
    key: 'additives',
    text: 'text_additives',
    active: false,
},
{
    key: 'colourants',
    text: 'text_colourants',
    active: false,
}]

// 过滤器过敏原
export const FILTER_ALLERGENS = [
    {
        key: 'gluten',
        text: 'text_gluten',
        active: false,
    }, {
        key: 'crustaceans',
        text: 'text_crustaceans',
        active: false,
    }, {
        key: 'eggs',
        text: 'text_eggs',
        active: false,
    }, {
        key: 'fish',
        text: 'text_fish',
        active: false,
    }, {
        key: 'peanuts',
        text: 'text_peanuts',
        active: false,
    }, {
        key: 'soya',
        text: 'text_soya',
        active: false,
    }, {
        key: 'milk',
        text: 'text_milk',
        active: false,
    }, {
        key: 'tree_nuts',
        text: 'text_tree_nuts',
        active: false,
    }, {
        key: 'celery',
        text: 'text_celery',
        active: false,
    }, {
        key: 'mustard',
        text: 'text_mustard',
        active: false,
    }, {
        key: 'sesame',
        text: 'text_sesame',
        active: false,
    }, {
        key: 'sulphites',
        text: 'text_sulphites',
        active: false,
    }, {
        key: 'lupin',
        text: 'text_lupin',
        active: false,
    }, {
        key: 'molluscs',
        text: 'text_molluscs',
        active: false,
    },
]

// 配料(其他菜品标识)
export const INGREDIENTS = [
    {
        key: 'mild_spicy',
        text: 'text_mild_spicy',
        active: false,
    },
    {
        key: 'medium_spicy',
        text: 'text_medium_spicy',
        active: false,
    },
    {
        key: 'very_spicy',
        text: 'text_very_spicy',
        active: false,
    },
    {
        key: 'frozen_origin',
        text: 'text_frozen_origin',
        active: false,
    },
    {
        key: 'blast_freezing',
        text: 'text_blast_freezing',
        active: false,
    },
    {
        key: 'vegetarian',
        text: 'text_vegetarian',
        active: false,
    },
    {
        key: 'vegan',
        text: 'text_vegan',
        active: false,
    },
    {
        key: 'gluten_free',
        text: 'text_gluten_free',
        active: false,
    },
    {
        key: 'raw',
        text: 'text_raw',
        active: false,
    },
    {
        key: 'cooked',
        text: 'text_cooked',
        active: false,
    },
    {
        key: 'additives',
        text: 'text_additives',
        active: false,
    },
    {
        key: 'colourants',
        text: 'text_colourants',
        active: false,
    }
]

export type AllergenItem = {
    key: string;
    active: boolean;
    text: string;
};